import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/users")({
  component: AdminUsers,
});

function AdminUsers() {
  return (
    <div>
      <div className="label-card">Super admin</div>
      <h1 className="mt-1 font-display text-3xl font-semibold">Admin users</h1>
      <p className="mt-2 text-ink-soft">
        Grant or revoke admin roles. Super-admin only.
      </p>
      <div className="mt-8 card-ledger p-8 text-center text-ink-soft">
        Admin user table mounts here once{" "}
        <code className="font-mono text-xs">/admin/users</code> endpoints are live.
      </div>
    </div>
  );
}
